
export default {
  name: "FGStyleSelector",
  props: {
    // 可选：父组件可传入初始选中索引
    defaultIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedIdx: 0,
      styles: [
        "Generic",
        "Cursive",
        "OldEnglish",
        "Script",
        "Traditional",
        "Gothic",
        "Typewriter",
        "Roman",
        "Chicano",
        "Calligraphy",
        "Graffiti",
        "Gangster",
        "Stencil",
        "Handwritten",
        "Minimalist",
        "Block",
        "Dark",
        "Classic",
        "Western",
        "Blackletter",
      ],
    };
  },
  mounted() {
    // 初始化时选中第一个并 emit
    this.selectedIdx = this.defaultIndex;
    this.emitSelected();
  },
  methods: {
    selectStyle(idx) {
      if (this.selectedIdx !== idx) {
        this.selectedIdx = idx;
        this.emitSelected();
      }
    },
    emitSelected() {
      // 向父组件发送选中的 style
      this.$emit("select", this.styles[this.selectedIdx]);
    },
  },
};
